import { render, staticRenderFns } from "./RelatorioRetornouOrigemListFiltroModalItem.vue?vue&type=template&id=1ba83786"
import script from "./RelatorioRetornouOrigemListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioRetornouOrigemListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports